import { YesObject } from '@yes.technology/react-toolkit'

import getOutputNode from './getOutputNode'

export default function getOutputTaskVisualizeHref(
  taskmodelUuid?: string,
  workflow?: YesObject[]
): string | undefined {
  const outputNode = getOutputNode(taskmodelUuid, workflow?.[0])

  if (outputNode?.type !== 'output_task_nodemodel') {
    return undefined
  }

  return `${globalThis.waInteractionUrl}${outputNode.handler.interactionmodel_uuid}?uuid_workflow=${workflow?.[0].uuid}&processValuesVariable=${outputNode.handler.target_container_variable}`
}
